import { ContentfulClick } from '@libs/analytics';
import { ColoredTextLink } from '../components/ColoredTextLink';
import type { LinkAction, LinkActionColor } from '../types';

type HeaderCtaTrackerProps = {
    textLink?: LinkAction;
    linkTextColor?: LinkActionColor;
    header: string;
    promoVariant: string;
    promoType: string;
};
export function HeaderCtaTracker({
    textLink,
    linkTextColor,
    header,
    promoVariant,
    promoType,
}: Readonly<HeaderCtaTrackerProps>) {
    const linkText = textLink?.actionText ?? '';
    const linkUrl = textLink?.link?.webUrl ?? '';
    const promoDesc = textLink?.internalTitle ?? '';
    const key = textLink?.sysId ?? '';

    return (
        <ContentfulClick
            key={key}
            color={linkTextColor}
            eventData={{
                linkText,
                linkUrl,
                promoTitle: header,
                promoVariant,
                promoDesc,
                promoType,
            }}
        >
            <ColoredTextLink href={linkUrl} color={linkTextColor}>
                {linkText}
            </ColoredTextLink>
        </ContentfulClick>
    );
}
